import React, { Dispatch, SetStateAction, createContext, useState } from 'react';

// context used to store onboarding navigation data used by the useSignupDialogNavigation hook
export const SignupDialogNavigationContext = createContext<{
    currentStepIndex: number;
    setCurrentStepIndex: Dispatch<SetStateAction<number>>;
    isLoadingStep: boolean;
    setIsLoadingStep: Dispatch<SetStateAction<boolean>>;
}>({
    currentStepIndex: 1,
    setCurrentStepIndex: () => {},
    isLoadingStep: false,
    setIsLoadingStep: () => {},
});

const SignupDialogNavigationContextProvider = ({ children }) => {
    const [currentStepIndex, setCurrentStepIndex] = useState(1);
    const [isLoadingStep, setIsLoadingStep] = useState(false);

    return (
        <SignupDialogNavigationContext.Provider
            value={{ currentStepIndex, setCurrentStepIndex, isLoadingStep, setIsLoadingStep }}>
            {children}
        </SignupDialogNavigationContext.Provider>
    );
};

export default SignupDialogNavigationContextProvider;
